import React, {useCallback} from "react"
import {TextModel} from "models/Text"
import connect from "./connect"
import {CTAWrapper, StyledCTA} from "./components"

interface TabbedFilterViewResultsProps {
    totalResults: number
    closeTabbedFilters: () => void
    text: TextModel
}

export const TabbedFilterViewResults = ({totalResults, closeTabbedFilters, text}: TabbedFilterViewResultsProps) => {
    const closeFiltersPanel = useCallback(() => {
        closeTabbedFilters()
    }, [closeTabbedFilters])

    return (
        <CTAWrapper data-testid="plp-filters-view-products-cta-button">
            <StyledCTA onClick={closeFiltersPanel}>
                {text.buttons.viewResults} {totalResults} {text.buttons.viewProducts}
            </StyledCTA>
        </CTAWrapper>
    )
}

export default connect(TabbedFilterViewResults)
